// removed by extract-text-webpack-plugin
module.exports = {"notFoundWrapper":"_2LqS-3uOUjo-0tl8eKpkqg","content":"_5a9XA-GmrvgsNIU2nL8hs","buttons":"_28wqzEZURMWCEzK5PMllR8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/UnsubscribePage/UnsubscribePage.scss
// module id = 1872
// module chunks = 0